<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">User</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        User Properties:
    </ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">First Name</ion-label>
                <ion-input color="secondary" type="text" name="firstName" #firstName="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required [(ngModel)]="user.firstName"
                    id="firstName" autofocus="true" data-test="firstName">
                </ion-input>
                @if (submitted && firstName.invalid) {
                <div data-test="firstNameErr">
                    <div class="validationErrorMsg">First name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Last Name</ion-label>
                <ion-input color="secondary" type="text" name="lastName" #lastName="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" required [(ngModel)]="user.lastName"
                    id="lastName" data-test="lastName">
                </ion-input>
                @if (submitted && lastName.invalid) {
                <div data-test="lastNameErr">
                    <div class="validationErrorMsg">Last name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Cell Phone</ion-label>
                <ion-input id="cellPhone" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx" 
                    [(ngModel)]="user.cellPhone" #cellPhone="ngModel" required name="cellPhone"
                    minlength="14" maxlength="14" data-test="cellPhone" 
                    [ngClass]="{'is-invalid': f.submitted && cellPhone.invalid}">
                </ion-input>
                @if (submitted && cellPhone.invalid) {
                <div data-test="cellPhoneErr">
                    <div class="validationErrorMsg">Cell phone is required.</div>
                </div>
                }
            </ion-item>

<!-- From ticket1Passenger
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Cell Phone</ion-label>
                <ion-input id="cellPhone" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx"
                    [(ngModel)]="vm.ticket.cellPhone" #cellPhone="ngModel" required name="cellPhone" minlength="14"
                    maxlength="14" data-test="cellPhone">
                </ion-input>
                @if (submitted && cellPhone.invalid) {
                <div>
                    <div class="validationErrorMsg">A 10 digit Cell Phone number is required.</div>
                </div>
                }
            </ion-item>
-->

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Email Address</ion-label>
                <ion-input color="secondary" type="email" name="email" #email="ngModel" class="ion-padding"
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required [(ngModel)]="user.email"
                    id="email" [readonly]="isReadonly()" data-test="email">
                </ion-input>
                @if (submitted && email.invalid) {
                <div data-test="emailErr">
                    <div class="validationErrorMsg">Email address is required.</div>
                </div>
                }
            </ion-item>

            <!-- We prompt for the role title and then set the role based on the title.ss -->
            <ion-item id="roleButton" (click)="onRoleClick()">
                <ion-label class="ion-text-wrap" position="stacked">Role</ion-label>
                <ion-input color="secondary" type="text" name="role" #role="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && role.invalid }" required [(ngModel)]="user.roleTitle"
                    id="role" [readonly]="isReadonly()" data-test="role">
                </ion-input>
                @if (submitted && role.invalid) {
                <div data-test="roleErr">
                    <div class="validationErrorMsg">Role is required.</div>
                </div>
                }
            </ion-item>
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick(f)" data-test="saveButton">Save</ion-button>
    </ion-toolbar>
</ion-footer>